module.exports = __webpack_public_path__ + "static/media/warning.12385555.svg";